import { AfterViewInit, Component, ContentChild, ContentChildren, EventEmitter, Input, OnChanges, Output, QueryList, SimpleChanges, ViewChild, Optional, Host, ChangeDetectorRef, ApplicationRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatColumnDef, MatTable, MatTableDataSource } from '@angular/material/table';
import * as moment from 'moment';
import { debounceTime } from 'rxjs/operators';
import { ComponentBase, RentalObjectInfo, T4DataService, T4DataSource } from 't4core';
import { HttpProgress, HttpProgressStatus } from '../../../../projects/t4core/src/lib/services/api.service';
import { createScheduledReportDialog } from '../../dialogs/createScheduledReportDialog/createScheduledReportDialog';

@Component({
    selector: 't4-data-table',
    templateUrl: './datatable.html',
    styleUrls: ['./datatable.css']
})

export class T4DatatableWidget extends ComponentBase implements AfterViewInit, OnChanges  {
    @Input() rawData = [];
    @Input() apiMethod = "";
    @Input() parameters:any = {};
    @Input() public headline: string;
    @Input() public autoGenerateColumns: boolean = true;
    @Input() public reportName: string;
    @Input() public reportDatabase: string = "Turbo";
    @Input() public cacheTimeInMinutes: number = 0;
    @Input() public showOnlyAddWhenEmpty: boolean = false;

    @Input() public allowFilter: Boolean = true;
    @Input() public allowPaging: Boolean = true;
    @Input() public allowAdd: Boolean = false;
    @Input() public allowMultiSelect: Boolean = false;
    @Input() public searchText: string;
    @Input() public searchAppearance: string = "fill";

    @Output() public itemClicked = new EventEmitter<RentalObjectInfo>();
    @Output() public addClicked = new EventEmitter<boolean>();
    @Output() public dataUpdated = new EventEmitter<boolean>();

    @Output() public filterChanged = new EventEmitter<boolean>();
    @Output() public itemSelected = new EventEmitter<any>();
    @Output() public itemDeselected = new EventEmitter<any>();

    private ctrlSorter: MatSort;
    @ViewChild(MatPaginator) ctrlPager: MatPaginator;
    @ViewChild(MatTable) tblData: MatTable<any>;
    @ContentChildren(MatColumnDef) public columnDefinitions !: QueryList<MatColumnDef>;

    public dynamicColumnDefs = [];

    public txtFilter: FormControl = new FormControl();
    @Input() public isLoadingData: boolean = false;
    public useFooter: boolean = false;

    public data:T4DataSource = new T4DataSource([], null, null, null);
    
    public activeColumns = [];
    public selectedRows = [];

    public scheduledReport: string = null;

    public isCached: boolean = false;
    public cacheTime: Date;

    @Input() public allowExcel: boolean = true;
    @Input() public filterFields: string[] = [];

    @Input() public exportTransformations: any;

  public isLoading: boolean = false;
  public loadingStatus: HttpProgress = { status: 4 };

  private isInitialized: boolean = false;

  constructor(private dialog: MatDialog, @Optional() @Host() sort: MatSort, private _app: ApplicationRef, private dataSvc: T4DataService) {
    super();
    this.ctrlSorter = sort;
    this.txtFilter.valueChanges.pipe(debounceTime(150))
      .subscribe(() => {
            if (this.data) this.data.filter = this.txtFilter.value;

            //if (this.selectedRows.length > 0) {
            //    this.data.data.filter(x => x.Checked).map(x => this.deselectRow(x));
            //}

            this.filterChanged.emit(true);
        });
  }

    public async ngAfterViewInit() {
      setTimeout(() => {
        this.update();
        this.isInitialized = true;
      }, 100);
    }

    private columnsCreated: boolean = false;
  public async update(clearColumns: boolean = false) {
    if (!this.columnDefinitions) return;
 
    if (clearColumns) {
      for (var i of this.columnDefinitions.toArray()) {
        this.tblData.removeColumnDef(i);
      }
      this.columnsCreated = false;
    }

    if (!this.columnsCreated && this.columnDefinitions.length > 0) {
      for (var i of this.columnDefinitions.toArray()) {
       this.tblData.addColumnDef(i);
      }
      if (i.footerCell) this.useFooter = true;

      this.columnsCreated = true;
    }

    var tmpData: any;
    this.isLoadingData = true;
    if (this.rawData && this.rawData.length > 0) {
      tmpData = new T4DataSource(this.rawData, this.ctrlSorter, this.allowPaging ? this.ctrlPager : null, this.headline, (item) => {
        var searchStr = "";
        if (this.filterFields) {
          for (var prop of this.filterFields) {
            var val = this.resolveProperty(item, prop);
            if (val) // Visible columns
              searchStr += val + "|";
          }
        } else {
          for (var prop in item) {
            if (this.columnDefinitions.filter(x => x.name == prop).length > 0) // Visible columns
              searchStr += item[prop] + "|";
          }
        }
        return searchStr;
      });
    }
    else if (this.apiMethod != "") {
      var x: Array<any>;
      this.isCached = false;
      this.cacheTime = null;

      // Check caching
      var callKey = this.Api.getUri(this.apiMethod, this.parameters);
      var cache = this.Cache.get("datatable_" + callKey);
      if (cache) {
        x = cache.data;
        this.isCached = true;
        this.cacheTime = cache.timestamp;
      }
      if (!x) {
        x = await this.Api.get<Array<any>>(this.apiMethod, this.parameters);

        if (this.cacheTimeInMinutes > 0) {
          this.Cache.put("datatable_" + callKey, x, new Date(new Date().getTime() + this.cacheTimeInMinutes * 60000));
        }
      }

      tmpData = new T4DataSource(x, this.ctrlSorter, this.allowPaging ? this.ctrlPager : null, this.headline, (item) => {
        var searchStr = "";
        if (this.filterFields) {
          for (var prop of this.filterFields) {
            var val = this.resolveProperty(item, prop);
            if (val) searchStr += val + "|";
          }
        } else {
          for (var prop in item) {
            if (this.columnDefinitions.filter(x => x.name == prop).length > 0) // Visible columns
              searchStr += item[prop] + "|";
          }
        }

        return searchStr;
      });


    }
    else if (this.reportName && this.reportName != "") {
      var x: Array<any>;
      this.isCached = false;
      this.cacheTime = null;

      var from = moment();
      var to = moment();

      if (this.parameters.from) from = this.parameters.from;
      if (this.parameters.to) to = this.parameters.to;

     //x = await this.dataSvc.GetReport(this.reportName, from, to);
      this.isLoading = true;
      if (!this.parameters.from) this.parameters.from = moment();
      if (!this.parameters.to) this.parameters.to = moment();
      x = await this.Api.call<any>("GET", "Data/GetReport", { reportName: this.reportName, from: this.parameters.from, to: this.parameters.to }, null, null, (x:HttpProgress) => {

        this.loadingStatus = x;
        if (x.status == HttpProgressStatus.Sent) console.log("Command sent");
        if (x.status == HttpProgressStatus.ProcessingOnServer) console.log("Processing on server");
        if (x.status == HttpProgressStatus.Uploading) console.log("Uploading: " + x.uploadPercentage + "%");
        if (x.status == HttpProgressStatus.Downloading) {
          if (x.downloadPercentage == Infinity) console.log("Downloading: " + x.downloadedBytes / 1000 + "kb");
          if (x.downloadPercentage != Infinity) console.log("Downloading: " + x.downloadPercentage + "%");
        }
      });
      this.isLoading = false;

      tmpData = new T4DataSource(x, this.ctrlSorter, this.allowPaging ? this.ctrlPager : null, this.headline, (item) => {
        var searchStr = "";
        if (this.filterFields) {
          for (var prop of this.filterFields) {
            var val = this.resolveProperty(item, prop);
            if (val) searchStr += val + "|";
          }
        } else {
          for (var prop in item) {
            if (this.columnDefinitions.filter(x => x.name == prop).length > 0) // Visible columns
              searchStr += item[prop] + "|";
          }
        }

        return searchStr;
      });
    }

    if (!tmpData) {
      tmpData = new T4DataSource([], this.ctrlSorter, this.allowPaging ? this.ctrlPager : null, this.headline, (item) => {
        var searchStr = "";
        if (this.filterFields) {
          for (var prop of this.filterFields) {
            var val = this.resolveProperty(item, prop);
            if (val) // Visible columns
              searchStr += val + "|";
          }
        } else {
          for (var prop in item) {
            if (this.columnDefinitions.filter(x => x.name == prop).length > 0) // Visible columns
              searchStr += item[prop] + "|";
          }
        }
        return searchStr;
      });
    }

    if (tmpData && tmpData.data.length > 0) {
      this.activeColumns = [];
      this.dynamicColumnDefs = [];

      if (this.allowMultiSelect) this.activeColumns.push("checkbox");

      var headers = tmpData.data[0];
      for (var prop in headers) {
        if (this.columnDefinitions && !this.columnDefinitions.find(x => x.name == prop) && this.autoGenerateColumns) this.dynamicColumnDefs.push({ columnDef: prop, header: prop });
      }

      this.columnDefinitions.forEach(x => this.activeColumns.push(x.name));
      this.dynamicColumnDefs.forEach(x => this.activeColumns.push(x.columnDef));

      tmpData.filter = this.txtFilter.value;
    }

    this.data = tmpData;
 
    this.selectedRows = this.data.data.filter(x => x.Checked);

    this.isLoadingData = false;
    this.checkScheduledReport();
    this.data.dataChanged.subscribe(x => this.dataUpdated.emit(x));
    this.dataUpdated.emit(true);

    //if (!clearColumns) {
    this._app.tick();
    //}

  }

    async ngOnChanges(changes: SimpleChanges) {

        var load = false;
        for (var x in changes) {
            if (x != "headline" && x != "allowMultiSelect") load = true;
        }

      if (this.isInitialized && load) setTimeout(() => this.update(), 100);
    }

    public toggleRowSelection(row: any) {
        if (row.Checked) {
            this.deselectRow(row);
        } else {
            this.selectRow(row);
        }
    }

    public selectRow(row: any, silent: boolean = false) {
        if (row.Checked) return;

        row.Checked = true;
        
      this.selectedRows = this.data.data.filter(x => x.Checked);
        if (!silent) this.itemSelected.emit(row);
    }

    public deselectRow(row: any, silent: boolean = false) {
        if (!row.Checked) return;

        row.Checked = false;
        this.selectedRows = this.data.data.filter(x => x.Checked);

        if (!silent) this.itemDeselected.emit(row);
  }

  public clearSelection() {
    for (var row of this.selectedRows) this.deselectRow(row);
  }

    public clearCache() {
        var callKey = this.Api.getUri(this.apiMethod, this.parameters);
        this.Cache.del("datatable_" + callKey);

        this.update();
    }

  public saveData() {
    this.data.export(this.exportTransformations ? this.exportTransformations : null);
  }

    public async toggleSchedule() {
        if (this.scheduledReport) {
            var x = await this.UI.confirm("Turbo.Core.CreateScheduledReportDialog.DeleteTitle", "Delete existing report?", "Turbo.Core.CreateScheduledReportDialog.DeleteMsg", 'A scheduled report for this table already exist. Do you want to delete it?');
            if (x) {
              var deleted = await this.dataSvc.DropReportSchedule(this.scheduledReport);
                if (deleted) {
                    this.UI.snackBar(this.translate("Turbo.Service.CreateScheduledReport.ReportDeletedSuccess.Message", "The scheduled report has been deleted."));
                    this.checkScheduledReport();
                }
                else {
                    this.UI.alert("Turbo.Service.CreateScheduledReport.ReportDeletedFailed.Headline", "Failed!", "Turbo.Service.CreateScheduledReport.ReportDeletedFailed.Headline.Message", "The scheduled report could not be deleted.");
                }
            }
        }
        else {
            const dialogConfig = new MatDialogConfig();
            dialogConfig.data = {
                reportName: this.reportName,
                reportDatabase: this.reportDatabase
            };

            const dialogRef = this.dialog.open(createScheduledReportDialog, dialogConfig);

            dialogRef.afterClosed().subscribe(
                data => this.checkScheduledReport());
        }
    }

    async checkScheduledReport() {
        if (this.reportName) {
            this.scheduledReport = await this.dataSvc.GetReportSchedule(this.reportName);
        }
    }

    private resolveProperty(obj: any, prop: string):any {
        var parts = prop.split(".");
        var data = obj;
        for (var p of parts) {
            if (!data[p]) return "";

            data = data[p];
        }

        return data;
    }
   
}
